"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const tabHeader_1 = require("./tabHeader");
const HOC_1 = require("../HOC");
class TabControlled extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { selected: 0 };
        7;
    }
    render() {
        const selected = this.props.value;
        const selectedItem = selected != null ? this.props.items[selected] : undefined;
        const body = selectedItem && selectedItem.body;
        return (React.createElement("div", null,
            React.createElement(tabHeader_1.TabHeaderView, { items: this.props.items, value: selected, onChange: x => this.props.onChange && this.props.onChange(x) }),
            this.props.items.map((x, i) => x.quitar ? ((i == selected) &&
                React.createElement("div", { key: x.key || x.title }, x.body)) : (React.createElement("div", { key: x.key || x.title, style: { display: (i == selected) ? undefined : "none" } }, x.body)))));
    }
}
exports.Tab = HOC_1.makeUncontrolled("value", "onChange", 0)(TabControlled);



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/tabs/tab.js
// module id = 2257
// module chunks = 0